import OfferType from 'apps/products/models/OfferType';
import groupBy from 'utils/groupBy';
import getAnalyticsSectionTitle from './getAnalyticsSectionTitle';

// this is used to validate property (key) of an object so as long as object properties are strings we have also to
// compare property to 'null' and 'undefined'
const isPropertyEmpty = (property) => (
  property === null || property === undefined || property === '' || property === 'null' || property === 'undefined'
);

const buildSingleImpressionsEvent = (
  pageType,
  sectionTitle,
  impressionFieldObjects,
  eventType = 'eecPromotionInteractionEvent'
) => {
  const universalAnalyticsEventData = {
    uaEventCategory: 'E-Commerce',
    uaEventAction: 'promotionImpressions',
    uaEventLabel: isPropertyEmpty(sectionTitle) ? `${pageType}|${pageType}` : `${pageType}|${sectionTitle}`,
    uaEventValue: impressionFieldObjects.length,
  };

  const pageTypeDimension = { pageTypeDimension: pageType };
  const productSectionDimension = isPropertyEmpty(sectionTitle) ? {} : { productSectionDimension: sectionTitle };

  const customDimension = {
    ...pageTypeDimension,
    ...productSectionDimension,
  };

  return {
    event: eventType,
    ...universalAnalyticsEventData,
    ...customDimension,
    ecommerce: {
      promoView: {
        promotions: impressionFieldObjects,
      },
    },
  };
};

const createPromotionImpressionField = (product, collectionOrderDetails) => ({
  id: product.offer.id || null,
  name: product.offer.type === OfferType.SMART_PASS_ELIGIBLE ? 'DISCOUNT_CLUB' : product.offer.text || null,
  creative: null,
  position: (collectionOrderDetails.fopInCollection || collectionOrderDetails.fopInCollection === 0)
    ? collectionOrderDetails.fopInCollection
    : null,
});

const createPromotionImpression = (promotionImpressionData, pageType) => {
  const { section, product, collectionOrderDetails } = promotionImpressionData;
  const sectionTitle = getAnalyticsSectionTitle(section, pageType);
  const impressionFieldObject = createPromotionImpressionField(product, collectionOrderDetails);
  return { sectionTitle, impressionFieldObject };
};

const mapImpressionsIntoEvents = (impressionsBySection, pageType, eventType) => (
  Object.entries(impressionsBySection)
    .map(([sectionTitle, impressions]) => buildSingleImpressionsEvent(pageType, sectionTitle, impressions, eventType))
);

const mapPromotionDataIntoImpression = impression => impression.impressionFieldObject;

const mapGraphicItemDataIntoImpression = (graphicImpressionData) => {
  const { id, id2, name, creative, position } = graphicImpressionData;
  return { id, id2, name, creative, position };
};

export function buildPromotionImpressionsEvents(eventData) {
  const { promotionImpressionsData, pageType } = eventData;
  const impressionObjects = promotionImpressionsData
    .map(promotionImpressionData => createPromotionImpression(promotionImpressionData, pageType));
  const impressionsBySection = groupBy(impressionObjects, 'sectionTitle', mapPromotionDataIntoImpression);
  return mapImpressionsIntoEvents(impressionsBySection, pageType, 'eecProductPromotionInteractionEvent');
}

export function buildGraphicImpressionsEvents(eventData) {
  const { graphicImpressionsData, pageType } = eventData;
  const impressionsBySection = groupBy(graphicImpressionsData, 'sectionTitle', mapGraphicItemDataIntoImpression);
  return mapImpressionsIntoEvents(impressionsBySection, pageType, 'eecPromotionInteractionEvent');
}
